import React, { useState } from 'react';
import { Box, Typography, Tabs, Tab, Grid, Grow, keyframes } from '@mui/material';
import { useTranslation } from 'react-i18next';
import InspirationCard from './InspirationCard';
import { travellerTypes, mostPopular, byMonth, inTheSpotlight } from './travelData';
import './styles.css';

const TravelInspiration = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const renderContent = () => {
    switch (activeTab) {
      case 0:
        return travellerTypes;
      case 1:
        return mostPopular;
      case 2:
        return byMonth;
      case 3:
        return inTheSpotlight;
      default:
        return [];
    }
  };

  const currentData = renderContent();

  return (
    <Box className="inspiration-container">
       <Typography
            variant="h3"
            component="h2"
            sx={{
              fontWeight: 500,
              mb: 3,
              lineHeight: 1.3,
              fontFamily: 'serif',
              color:'#005B4B'
            }}
          >
        {t('inspiration_headline')}
      </Typography>

      <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: '40px' }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          centered
          className="inspiration-tabs"
        >
          <Tab label={t('inspiration_tab_traveller')} className="inspiration-tab" />
          <Tab label={t('inspiration_tab_popular')} className="inspiration-tab" />
          <Tab label={t('inspiration_tab_month')} className="inspiration-tab" />
          <Tab label={t('inspiration_tab_spotlight')} className="inspiration-tab" />
        </Tabs>
      </Box>

      <Grid container spacing={0.5}>
        {currentData && currentData.map((item, index) => (
           <Grow in={true} key={index} timeout={500 * (index + 1)}>
            <Grid item size={{ xs: 12, sm: 6, md: 3 }}> 
                {/* 
                  THIS IS THE FIX: 
                  We are now passing `categoryKey` instead of `category`.
                  The `item` object from our map has `item.categoryKey`, not `item.category`.
                */}
                <InspirationCard image={item.image} categoryKey={item.categoryKey} />
            </Grid>
          </Grow>
        ))}
      </Grid>
    </Box>
  );
};

export default TravelInspiration;